<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import timeSlotList from "./time-slot-list";
    export default {
    components: { Layout, PageHeader, timeSlotList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <time-slot-list/>
  </Layout>
</template>